const getCorrectedPhoneNumbers = function (state, getters) {
  return function(collection: any[]) {
      const sortedCollection = getters.getSortedPhoneNumbers(collection)
      const augmentedCollection = getters.getAugmentedPhoneNumbers(sortedCollection)

    return augmentedCollection
  }
}

export default getCorrectedPhoneNumbers
